interface CheckoutCancelPageProps {
  navigate: (path: string) => void;
}

export default function CheckoutCancelPage({ navigate }: CheckoutCancelPageProps) {
  return (
    <section className="page auth-page">
      <div className="auth-panel">
        <span className="eyebrow">Checkout cancelled</span>
        <h1>No payment captured</h1>
        <p>You can return to the event listing and start again whenever you are ready.</p>
        <button className="primary-action" onClick={() => navigate("/tickets")}>View tickets</button>
      </div>
    </section>
  );
}
